"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThermalFusion = void 0;
const GlobalEventName_1 = require("../GlobalEventName");
const PartyName_1 = require("../../parties/PartyName");
const Resources_1 = require("../../../Resources");
class ThermalFusion {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.THERMAL_FUSION;
        this.description = 'Convert all energy into heat. Gain 2 heat for each energy production (max 5) and influence.';
        this.revealedDelegate = PartyName_1.PartyName.POPULISTS;
        this.currentDelegate = PartyName_1.PartyName.EMPOWER;
    }
    resolve(game, turmoil) {
        game.increaseOxygenLevel(game.getPlayers()[0], 1);
        game.getPlayers().forEach((player) => {
            player.addResource(Resources_1.Resources.HEAT, player.energy);
            player.deductResource(Resources_1.Resources.ENERGY, player.energy);
            const amount = Math.min(player.getProduction(Resources_1.Resources.ENERGY), 5) + turmoil.getPlayerInfluence(player);
            if (amount > 0)
                player.addResource(Resources_1.Resources.HEAT, amount * 2, { log: true });
        });
    }
}
exports.ThermalFusion = ThermalFusion;
//# sourceMappingURL=ThermalFusion.js.map